import { useEffect, useState } from "react";

import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";

import { IdeaContext } from "./hooks/useIdea";

export const IdeaProvider = ({
  children,
  ideaId: forcedIdeaId,
}: {
  children: React.ReactNode;
  ideaId?: string;
}) => {
  const [searchParams] = useSearchParams();
  const searchIdeaId = searchParams.get("idea");
  const params = useParams();
  const [ideaId, setIdeaId] = useState(
    forcedIdeaId || searchIdeaId || params.ideaId,
  );
  const [childId, setChildId] = useState<string | undefined | null>(undefined);
  useEffect(() => {
    setIdeaId(forcedIdeaId || searchIdeaId || params.ideaId);
    setChildId(null);
  }, [forcedIdeaId, searchIdeaId, params.ideaId]);

  return (
    <IdeaContext.Provider value={{ ideaId, setIdeaId, childId, setChildId }}>
      {children}
    </IdeaContext.Provider>
  );
};
